
var CanvasRenderer__prototype = CanvasRenderer.prototype;